import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { Alerta } from "../constants";

const initialState = {
  empresas: [],
  alertasByEmpresaId: {},
  filtro: {
    sucessos: false,
    avisos: false,
    erros: false,
    inativas: false,
    ativas: true,
    tabs: [],
  },
  empresasFiltradas: [],
};

export const empresasSelector = (state) => state.empresas.empresas;
export const alertasByEmpresaIdSelector = (state) => state.empresas.alertasByEmpresaId;
export const filtroSelector = (state) => state.empresas.filtro;
export const filtradoSelector = createSelector(filtroSelector, (filtro) => !!filtro.sucessos || !!filtro.avisos || !!filtro.erros || !!filtro.ativas || !!filtro.inativas || filtro.tabs.length > 0);
export const empresasFiltradasSelector = createSelector(empresasSelector, alertasByEmpresaIdSelector, filtroSelector, filtradoSelector, (empresas, alertasByEmpresaId, filtro, filtrado) =>
  empresas.filter((empresa) => {
    if (filtro.ativas && !empresa.ativa) return false;
    if (filtro.inativas && empresa.ativa) return false;
    if (!filtrado) return true;
    const alertas = alertasByEmpresaId[empresa.id] ?? [];
    for (const alerta of alertas) {
      if (filtro.tabs.length > 0) {
        if (!filtro.tabs.includes(alerta.nome)) {
          continue;
        }
      }
      if (filtro.sucessos && alerta.totalByNivel[Alerta.Nivel.OK.id] === 0)
        continue;
      if (filtro.avisos && alerta.totalByNivel[Alerta.Nivel.Aviso.id] === 0)
        continue;
      if (filtro.erros && alerta.totalByNivel[Alerta.Nivel.Erro.id] === 0)
        continue;
      return true;
    }
    return false;
  }),
);

export const fetchEmpresas = createAsyncThunk("empresas/fetchEmpresas", async ({ search, acessoId, modulo }, thunkAPI) => {
  try {
    const empresas = (await axios.get("/empresas", { params: { search, acesso: acessoId } })).data;
    modulo && thunkAPI.dispatch(fetchAlertas({ acessoId, empresas, modulo }));
    return empresas;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchAlertasByEmpresa = createAsyncThunk("empresas/fetchAlertasByEmpresa", async ({ id, modulo }, thunkAPI) => {
  try {
    return (
      await axios.get(`/empresas/${id}/verificar-alertas`, {
        params: { modulo },
      })
    ).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchAlertas = createAsyncThunk("empresas/fetchAlertas", async ({ acessoId, empresas, modulo }, thunkAPI) => {
  try {
    if (acessoId || empresas.length <= 10)
      return await Promise.all(
        empresas.map((empresa) =>
          axios
            .get(`/empresas/${empresa.id}/verificar-alertas`, {
              params: { modulo },
            })
            .then((res) => ({ id: empresa.id, abas: res.data })),
        ),
      );
    else return await axios.get(`/empresas/verificar-alertas`, { params: { modulo } }).then((res) => res.data.map((row) => ({ id: row.empresaId, abas: row.alertas })));
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const slice = createSlice({
  name: "empresas",
  initialState,
  reducers: {
    filtrarEmpresas(state, action) {
      state.filtro.sucessos = action.payload.sucessos ?? state.filtro.sucessos;
      state.filtro.avisos = action.payload.avisos ?? state.filtro.avisos;
      state.filtro.erros = action.payload.erros ?? state.filtro.erros;
      state.filtro.inativas = action.payload.inativas ?? state.filtro.inativas;
      state.filtro.ativas = action.payload.ativas ?? state.filtro.ativas;
      state.filtro.tabs = action.payload.tabs ?? state.filtro.tabs;
    },
    limparEmpresas(state, action) {
      state.empresas = [];
      state.alertasByEmpresaId = {};
      state.empresasFiltradas = [];
    },
  },
  extraReducers: {
    [fetchEmpresas.fulfilled]: (state, action) => {
      state.empresas = action.payload;
    },
    [fetchAlertasByEmpresa.fulfilled]: (state, action) => {
      state.alertasByEmpresaId[action.meta.arg.id] = action.payload;
    },
    [fetchAlertas.fulfilled]: (state, action) => {
      state.alertasByEmpresaId = action.payload.reduce((pv, cv) => {
        pv[cv.id] = cv.abas;
        return pv;
      }, {});
    },
  },
});

export default slice.reducer;

export const { filtrarEmpresas, limparEmpresas } = slice.actions;
